$(() => {
	const cardModule = $('.card');
	const platformAccordion = $('.bs-section--platform-r-imgacc-l3-cnvsgt1');
	if (platformAccordion.length > 0) {
    $(cardModule).each((index, element) => {
      const contents = $(element).find(".card-body p");
      let cardHeader = $(element).find(".card-header");
      $(cardHeader).append(contents);
    });
	}
});


